import {defineStore} from "pinia";
import type {Locale} from "~/types/Locale";
import {createDefaultLocale} from "~/types/Locale";
import axios from "axios";

export const useLocaleStore = defineStore('locale', {
    state: () => ({
        locales: [] as Locale[],
        currentLocale: createDefaultLocale() as Locale,
    }),
    actions: {
        async fetchLocales() {
            try {
                const response = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/v1/languages`);
                this.locales = response.data.data as Locale[];
            } catch (error) {
                console.error(error);
            }
        },
        async getLocales() {
            if (this.locales.length === 0) {
                await this.fetchLocales();
            }
            return this.locales;
        },
        async setCurrentLocale(locale: Locale) {
            this.currentLocale = locale;
        }
    },
    persist: {
        storage: persistedState.sessionStorage,
        paths: [
            'locales',
            'currentLocale',
        ],
        key: 'localeStore',
    }
});